var exports = {
  "Nr": "card__WEqGRj",
  "U1": "headerRow__usBGLn",
  "Um": "pushLabels__dtA0-6",
  "X2": "mutedText__VDHaCh",
  "G5": "mobileOverflowMenu__oDKFoH",
  "Eg": "desktopOverflowMenu__A33o9S",
  "xv": "truncate__u1Uy83",
  "df": "commitMessage__ti06KT",
};

module.exports = exports;
